/**
 * Where the member API lives.
 *
 * Defaults to the same origin, which is what makes the Static Web Apps session work: the principal
 * header is only injected for requests that go through the site's own domain, so pointing this at an
 * absolute URL costs every endpoint its identity.
 */
export const API_BASE = process.env.GATSBY_API_BASE_URL || '/api';

/** True when API_BASE points somewhere other than this site. */
export const isCrossOriginApi = /^https?:\/\//i.test(API_BASE);
